var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('shelve-form')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-11 col-md-10"},[_c('shelved')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }